import { createSelector } from "@reduxjs/toolkit";
import { Routes } from "const";
import { AuthSelector, RouterSelector } from ".";
import { CustomerSelector } from "./customer-selector";
import { PortfolioSelector } from "./portfolio-selector";

export const MenuSelector = {
  forceHideAllMenu: (state) => AuthSelector.forceHideAllMenu(state),
  hideMainMenuEx: (state) => PortfolioSelector.isRmUser(state),
  hideAllMenu: (state) => {
    const { pathname } = RouterSelector.location(state);
    const forceHideAllMenu = AuthSelector.forceHideAllMenu(state);
    const isCurrentPageDisclaimer = Routes.Disclaimer === pathname;
    const isCurrentPageUltraHighHome = Routes.UltraHigh.Home === pathname;
    const shouldRegisterOrRedoSuitabilityTest = !CustomerSelector.registerAndSuitabilityAreValid(state);

    return (
      forceHideAllMenu || isCurrentPageDisclaimer || shouldRegisterOrRedoSuitabilityTest || isCurrentPageUltraHighHome
    );
  },
  showMainMenu: createSelector(
    [(state) => CustomerSelector.state(state).isUhnwUser, (state) => RouterSelector.location(state).pathname],
    (isUhnwUser, pathname) => {
      const isNotCurrentPageDisclaimer = Routes.Disclaimer !== pathname;
      const isNotUltraHighHomePage = Routes.UltraHigh.Home !== pathname;
      return isUhnwUser && isNotUltraHighHomePage && isNotCurrentPageDisclaimer;
    }
  ),
};
